import dayjs from 'dayjs'

import { AMENDMENT_JOURNEY_DATE_LABELS, AMENDMENT_PAX_DEFAULT_NAME } from '@/constants/pages/amendmentSelectDates'
import type {
  AmendmentJourneyRow,
  AmendmentPassengerRow,
  TravellerDetailsFlight,
  TravellerDetailsPax,
} from '@/types/amendTraveller'

function segmentEndpointLabel(codeCity: string): string {
  const i = codeCity.indexOf('_')
  if (i === -1) return codeCity
  return codeCity.slice(i + 1) || codeCity
}

function formatJourneyTime(iso: string): string {
  return dayjs(iso).isValid() ? dayjs(iso).format('HH:mm') : '—'
}

function formatJourneyDateLabel(iso: string): string {
  return dayjs(iso).isValid() ? dayjs(iso).format('D MMM YYYY') : ''
}
export function mapJourneyListFromFlights(
  flightList: TravellerDetailsFlight[],
  isRt: boolean
): AmendmentJourneyRow[] {

  return flightList.map((flight, index) => {
    const isReturnLeg = isRt && index > 0
    const from = segmentEndpointLabel(flight.from)
    const to = segmentEndpointLabel(flight.to)
    return {
      id: String(flight.id),
      routeLabel: `${from} → ${to}`,
      scheduledTime: formatJourneyTime(flight.travelDate),
      scheduledDateLabel: formatJourneyDateLabel(flight.travelDate),
      originalTravelDateIso: flight.travelDate,
      newDateFloatLabel: isReturnLeg
        ? AMENDMENT_JOURNEY_DATE_LABELS.NEW_RETURN
        : AMENDMENT_JOURNEY_DATE_LABELS.NEW_DEPARTURE_FLOAT,
      newDatePlaceholder: isReturnLeg
        ? AMENDMENT_JOURNEY_DATE_LABELS.NEW_RETURN
        : AMENDMENT_JOURNEY_DATE_LABELS.OUTBOUND_PLACEHOLDER,
      defaultSelected: index === 0,
    }
  })
}

export function mapPaxList(paxInfoList: TravellerDetailsPax[]): AmendmentPassengerRow[] {
  return paxInfoList.map((paxInfo, index) => {
    const { id, title, fname, lname } = paxInfo
    const fullName =
      [title, fname, lname].filter(Boolean).join(' ').trim() || AMENDMENT_PAX_DEFAULT_NAME
    const paxId = String(id)
    const defaultSelected = index === 0
    return {
      id: paxId,
      fullName,
      defaultSelected,
    }
  })
}
